import fonts from './fonts';
import colors from './colors';

export {
  fonts,
  colors
}



// WEBPACK FOOTER //
// ./src/styleguide/index.js